import { useInView } from "react-intersection-observer";
import how from '../assets/images/how.png';

const How = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: '-100px 0px',
  });

  return (
    <div className="h-screen bg-cover overflow-hidden">
      <div className="hidden md:block h-screen">
        <div ref={ref} className="max-w-[1000px] h-full w-full mx-auto flex items-center justify-around">
          <img src={how} alt=""  className="max-h-240-mobile-touch max-h-600-desktop-pointer"/>
        </div>
      </div>
      <div className="md:hidden flex justify-center items-center h-screen">
        <div ref={ref} className="max-w-[550px] h-full w-full mx-auto flex items-center justify-around">
          <img src={how} alt="" />
        </div>
      </div>
    </div>
  );
};

export default How;